import { defineStore } from 'pinia'
import axios from '@/utils/axios'

export const useStatesStore = defineStore('states', {
  state: () => ({
    cache: {},
  }),
  persist: true,
  actions: {
    async loadStates(country_id) {
      if (this.cache[country_id]) {
        return this.cache[country_id];
      }
      const response = await axios.get(`/states/${country_id}`);
      this.cache[country_id] = response.data.data;
      return this.cache[country_id];
    },
        clearCache() {
        this.cache = {}
    }
  }
})